import { RESULTS } from '@/utils/constants'

export default {
  transform (filters) {
    return Object.keys(filters)
      .filter((key) => filters[key] && !filters[key].toString().endsWith('_NONE'))
      .reduce((obj, filter) => {
        if (!RESULTS.ALLOWED_ADDRESS_FIELDS.includes(filter)) {
          return { ...obj, [filter]: filters[filter] }
        }
        return obj
      }, {})
  },
}
